/**
 * @ignore
 */
export class DialogConfig<D = any> {
  data?: D;
  userClass?: string;
  backdrop?: boolean; //æ¯å¦åè®¸ç¹å»ç©ºç½å¤å³é­ï¼é»è®¤å¼å¯;
}
